import React, { useEffect, useState } from "react";
import "./Agents.scss";
import TableFilterHeader from "../../components/TableHeader/TableFilterHeader";
import { useSelector, useDispatch } from "react-redux";
import { getUserList } from "../../store/redux/users";
import { getUsers, getUserDetails } from "../../util/API/customers";
import { listMerchantByPrograms } from "../../util/API/agent";
import { getAgentsList } from "../../store/redux/agents";
import AgentTable from "../../components/AgentTable/AgentTable";
import CreateAgentModal from "../../components/CreateAgentModal/CreateAgentModal";
import TableInfoHeaderAgent from "../../components/TableInfoHeader/TableInfoHeaderAgent";
import AgentTabs from "../../components/AgentTabs/AgentTabs";
import AgentDetails from "../../components/AgentDetails/AgentDetails";
import AgentMapModal from "../../components/AgentMapModal/AgentMapModal";
import LoadingPage from "../../components/UI/LoadingPage/LoadingPage";
import { searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";
import axios from "axios";
import { Box } from "@mui/material";

function Agent() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [previousUsers, setPreviousUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [open, setOpen] = useState({
    create: false,
    map: false
  });
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const [securityPermissions, setSecurityPermissions] = useState([]);

  //Security Roles
  const securityAccess = useSelector((state) => state.login.securityAccess);
  let isAdmin = sessionStorage.getItem("isAdmin");

  useEffect(() => {
    const securityUser = searchAppsByLabel("agent", securityAccess);

    if (securityUser.length) {
      setSecurityPermissions(securityUser[0]);
    }
  }, []);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleCreateOpen = () => setOpen({...open, create: true});
  const handleMapOpen = () => setOpen({...open, map: true});

  const handleCreateClose = () => setOpen({...open, create: false});
  const handleMapClose = () => setOpen({...open, map: false});  


  const dispatch = useDispatch();
  const userData = useSelector((state) => state.usersList.users);
  const agentData = useSelector((state) => state.agentList.users);
  const previousUserData = useSelector(
    (state) => state.previousUsers.previousUsers
  );

  useEffect(() => {
    async function getList() {
      let userList = await getUsers();
      dispatch(getUserList({ users: userList }));
    }

    // if (userData == null) {
    getList();
    // }
  }, []);

  useEffect(() => {
    if (userData) {
      if (searchText.trim() === "") {
        setFilteredUsers(agentData);
      } else {
        const filtered = agentData.filter(
          (user) =>
            user.Vmerchantpi.businessname
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            user.Vmerchantpi.businesscountry
              .toLowerCase()
              .includes(searchText.toLowerCase())
        );
        setFilteredUsers(filtered);
      }
    }
  }, [userData, searchText]);

  useEffect(() => {
    const fetchAgents = async () => {
      const response = await listMerchantByPrograms();
      if (response.callStatus == 1) {
        let agentList = response.payload.body.record;
        dispatch(getAgentsList({ users: agentList }));
      } else {
        dispatch(getAgentsList({ users: [] }));
      }
    };

    fetchAgents();
  }, []);

  const setFilter = (filter) => {
    setFilterType(filter);
  };

  const handleSelectedUser = async (selectedCustomer) => {
    console.log(selectedCustomer);
    setSelectedUser(selectedCustomer);
    const userDetails = await getUserDetails(
      selectedCustomer.Vmerchantpi.userid
    );
    console.log(userDetails);
    setSelectedUserData(userDetails);
  };

  const handleSearch = (searchText) => {
    setSearchText(searchText);
    if (searchText.trim() === "") {
      setFilteredUsers(agentData);
    } else {
      const filtered = agentData.filter(
        (user) =>
          user.Vmerchantpi.businessname
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          user.Vmerchantpi.businesscountry
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  };

  return (
    <>
      <AgentMapModal open={open.map} handleClose={handleMapClose} />
      {filteredUsers ? (
        <>
          <CreateAgentModal open={open.create} handleClose={handleCreateClose} />
          <Box className="page-container crm-container">
            <Box sx={{mb: 2}}>
              <Box
                className={`page-title ${
                  scrollPosition > 105 ? "fixed-filter-header" : ""
                }`}
                style={{ transition: "all 0.5s ease-in-out" }}
              >
                <Box className="crm-row-style">
                  <p
                    className={scrollPosition > 105 ? "hide" : "padding-header"}
                  >
                    Agents
                  </p>
                  <TableFilterHeader
                    handleSearch={handleSearch}
                    setOpen={handleCreateOpen}
                    isAdmin={isAdmin}
                    pageName={"Agents"}
                  />
                </Box>
              </Box>
              <Box sx={{ mt: 2 }}>
                <CustomMap />
              </Box>
            </Box>

            <Box className="customer-table-container">
              <TableInfoHeaderAgent
                count={filteredUsers.length}
                setFilter={setFilter}
                handleOpen={handleMapOpen}
                user={"Agents"}
              />

              <AgentTable
                userData={filteredUsers}
                handleSelectedUser={handleSelectedUser}
              />
            </Box>

            <Box
              class="offcanvas offcanvas-end dynamic-offcanvas"
              tabindex="-1"
              id="offcanvasRightLoan"
              aria-labelledby="offcanvasRightLabel"
            >
              <Box className="customer-bottom-info">
                <Box class="text-end p-2">
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </Box>
                <Box className="customer-bottom-box2">
                  <AgentDetails
                    selectedUser={selectedUser}
                    setSelectedUserData={setSelectedUserData}
                  />
                </Box>

                <Box className="customer-bottom-box">
                  <AgentTabs
                    selectedUser={selectedUser}
                    selectedUserData={selectedUserData}
                    setSelectedUserData={setSelectedUserData}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <LoadingPage />
      )}
    </>
  );
}



export default Agent;

const CustomMap = () => {
  const [iframeSrc, setIframeSrc] = useState("");

  const getPhp = async () => {
    try {
      const response = await axios.get("https://dev2.4pay.ca/lab/map/mymap.php", {
        responseType: "blob", // Important to handle the response as a Blob
      });

      const blob = new Blob([response.data], { type: "text/html" });
      const url = URL.createObjectURL(blob);

      setIframeSrc(url);
    } catch (error) {
      console.error("Error fetching the map HTML", error);
    }
  };

  useEffect(() => {
    getPhp();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: 400,
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 3,
      }}
    >
      {iframeSrc && (
        <iframe
          src={iframeSrc}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
        />
      )}
    </Box>
  );
};

// const CustomMap = () => {
//   const [mapHtml, setMapHtml] = useState("");

//   const getPhp = async () => {
//     try {
//       const response = await axios.get("https://dev2.4pay.ca/lab/map/mymap.php");
//       setMapHtml(response.data);
//       console.log(response.data)
//     } catch (error) {
//       console.error("Error fetching the map HTML", error);
//     }
//   };

//   useEffect(() => {
//     getPhp();
//   }, []);

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         height: 400,
//         borderRadius: 2,
//         overflow: "hidden",
//         boxShadow: 3,
//         backgroundColor: "white",
//       }}
//       dangerouslySetInnerHTML={{ __html: mapHtml }}
//     />
//   );
// };

